const SEP20_CONTRACT_ACTION_TYPES = {
  SEP20_CONTRACT_SET: "sep20/CONTRACT_SET",
};

export default SEP20_CONTRACT_ACTION_TYPES;
